import URL from '../url'
import Request from '../request'

export const listTagsService = () =>
  new Request(URL.API, URL.TAG_LIST).get()

export const createTagService = entity =>
  new Request(URL.API, URL.TAG_CREATE).post(entity)

export const updateTagService = (id, entity) =>
  new Request(URL.API, URL.TAG_UPDATE.replace('{id}', id)).put(entity)

export const deleteTagService = id =>
  new Request(URL.API, URL.TAG_DELETE.replace('{id}', id)).delete()
